module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-whyus-photo-01.jpg?h=1d5a3afdc6d5ea024aae1ae250c27537";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-01.jpg
// module id = 2108
// module chunks = 12 15